import React from 'react';
import { ProductOffers } from 'widgets/ProductOffers/ProductOffers';

const ProposalProductSelection = ({ datasource }) => (
    <ProductOffers datasource={datasource} />
);

export default ProposalProductSelection;
